import { default as UUID } from "node-uuid";
import { __ } from "src/libs/utilities";
import { IPETest } from "../interfaces";
import { useTestsStore } from "../store";

export default function getDefaultTest(): IPETest {
    const genTests: IPETest[] = useTestsStore.getState().genTests || []
    return {
        id: UUID.v4(),
        title: __("New Test") + " " + (genTests.length + 1),
        post_content: "",
        questions: [],
        is_show_answer: false,
        is_show_results: true,
        is_shuffle: true,
        try_count: 0, 
        pe_academic_discipline: []
    } as IPETest
}